import React, { useState, useEffect } from "react";
import { Box, Container, makeStyles, Typography } from "@material-ui/core";
import Page from "src/components/Page";
import Form from "./Form";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import { apiEndpoints, apiGetByIdRequest } from "src/utils/api/api";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  title: {
    marginLeft: theme.spacing(3),
  },
}));

const NewsPreviewForm = ({
  enableGlobalLoader,
  disableGlobalLoader,
  ...rest
}) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { entryId, returnId, pageCount } = useParams();
  const [news, setNews] = useState(null);
  const editMode = rest.kmaction === "edit";

  let pageTitle = news ? news.title : "Artykuł";

  useEffect(() => {
    enableGlobalLoader();
    apiGetByIdRequest(apiEndpoints.getNewsDetails.path,
      entryId,
      true
    )
      .then((data) => {
        disableGlobalLoader();
        setNews(data);
      })
      .catch((error) => {
        disableGlobalLoader();
      });
    return () => {};
  }, []);

  return (
    <Page className={classes.root} title={pageTitle}>
    

      <Container maxWidth={false}>
        <Box mt={3}>
          <Form
            news={news}
            returnId={returnId}
            pageCount={pageCount}
          />
        </Box>
      </Container>
    </Page>
  );
};

const mapDispatchToProps = (dispatch) => ({
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
});

export default connect(null, mapDispatchToProps)(NewsPreviewForm);
